import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
// @mui
import { Box, Stack, Dialog, Grid, Button, AppBar, Typography, Container, Slide } from '@mui/material';
// components
import { useSettingsContext } from 'src/components/settings/context';
import { setCurrentTreatmentDataGlobal } from 'src/redux/slices/multiTreatment';
import { AddAppointmentPopup } from '../dialogPopUp';
import { clearLead } from '../../redux/slices/lead';
import { dispatch } from '../../redux/store';
import { commonDialogHeaderStyle, onBoardDialogHeader, reminderDialogStyle, reminderTitleStyle, cancelBoxStyle, reminderStackStyle } from '../../styles/ScheduleReminder';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function OpenAppointmentPopup({ open, onClose, onBooked, onBusyChange, isScopeCurrent, modeControl, inputRef, headerButtons, treatmentData, type }) {
    const settings = useSettingsContext();

    const handleClose = async (status, id) => {
        if (isScopeCurrent && !isScopeCurrent()) return;
        if (String(status).toLowerCase() === 'finish') {
            onBooked?.({ booked: true, leadId: id });
        }
        dispatch(clearLead());
        dispatch(setCurrentTreatmentDataGlobal(null));
        onClose(status, id);
    };

    return (
        <Dialog
            fullScreen
            TransitionComponent={Transition}
            open={open}
            onClose={handleClose}
            sx={reminderDialogStyle}
        >
            <AppBar sx={headerButtons ? commonDialogHeaderStyle : onBoardDialogHeader}>
                <Typography
                    sx={reminderTitleStyle}
                    variant="h6"
                    component="div"
                >
                    Add appointment
                </Typography>
                {headerButtons &&
                    <Box sx={cancelBoxStyle}>
                        <Button
                            color="inherit"
                            variant='outlined'
                            style={{ borderColor: '#FFFFFF', color: '#fff' }}
                            onClick={() => { handleClose('close'); }}
                        >
                            Cancel
                        </Button>
                    </Box>
                }
            </AppBar>
            <Stack spacing={2} sx={reminderStackStyle}>
                {modeControl}
                <Grid container spacing={1} sx={{ maxWidth: '1088px', margin: 'auto' }}>
                    <Container
                        maxWidth={settings.themeStretch ? false : 'xl'}
                    >
                        <AddAppointmentPopup handleClose={handleClose} onBusyChange={onBusyChange} isScopeCurrent={isScopeCurrent} inputRef={inputRef} treatmentData={treatmentData} type={type} />
                    </Container>
                </Grid>
            </Stack>
        </Dialog>
    );
}

OpenAppointmentPopup.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onBooked: PropTypes.func,
    onBusyChange: PropTypes.func,
    isScopeCurrent: PropTypes.func,
    modeControl: PropTypes.node,
    inputRef: PropTypes.any,
    headerButtons: PropTypes.bool,
    treatmentData: PropTypes.any,
    type: PropTypes.string
};
